import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { CatJobPositionBIModel } from 'src/app/model/cat-job-position-bi.model';

@Injectable({
  providedIn: 'root'
})
export class CatJobPositionBiService {
  private url:string;

  ////////////////
  constructor(
    private http:HttpClient
  ) {
    this.url=environment.services_url;
  }

  //
  catalog=()=> {
    return this.http.get(`${this.url}/CatJobPositionBI/Catalog`)
      .pipe(
        map((resp:any)=> resp)
      );
  }
  getAll=()=> {
    return this.http.get(`${this.url}/CatJobPositionBI/List`)
      .pipe(
        map((resp:any)=> resp)
      );
  }
  getAllActive=()=> {
    return this.http.get(`${this.url}/CatJobPositionBI/List`)
      .pipe(
        map((resp:any)=> resp.filter(job=> job.activeId))
      );
  }


  save=(position:CatJobPositionBIModel)=> {
    return this.http.post(`${this.url}/CatJobPositionBI/SaveUpdate`, position)
      .pipe(
        map((resp:any)=> resp)
      );
  }
  update=(position:CatJobPositionBIModel)=> {
    return this.http.post(`${this.url}/CatJobPositionBI/SaveUpdate/${position.jobPositionBiId}`, position)
      .pipe(
        map((resp:any)=> resp)
      );
  }
}
